import { Avatar, Box, Button, useMediaQuery } from '@mui/material'
import { Menu as MenuIcon, Close } from '@mui/icons-material';
import { ArrowRightIcon } from '../../../../../core/global/Icons';
import { ToolCategories } from '../../../toolcategories/Index';
import pofsis from '../../../../../assets/images/logos/smallPOFSIS.png'

export const Mobile = ({divID, navFeature, open, setOpen, registration, login, redirectHandler, handleClickContactUs, HandleClickTC}) => {
    const mobilexs = useMediaQuery('(max-width:340px)');
   
    return (
        <Box height="76px" width="100%" sx={{position: 'fixed', zIndex:1200}} bgcolor={open ? '#FFFFFF':"#003022"}>
            <Box height="100%" width="100%" display="flex" justifyContent="space-between" alignItems="center" px={mobilexs? '12px':"24px"} gap="8px">
                <Box height="100%" display="flex" justifyContent="center" alignItems="center" gap={mobilexs? '8px':"16px"}>
                    {open ? 
                        <Close onClick={HandleClickTC} sx={{color:'#003F2E', height:28, width:28}}/> 
                    :
                        <MenuIcon onClick={HandleClickTC} sx={{height:28, width:28, color:'#DAE8DA'}}/> 
                    }
                    <Avatar src={pofsis} variant='square' sx={{height:'32px', width:'32px'}}/>
                </Box>
                <Box height="100%"  display="flex" justifyContent="center" alignItems="center" gap={mobilexs? '8px':"16px"}>
                    <Button onClick={registration} variant="contained" color="primary" sx={{m:'0px !important', p:'0px !important', borderRadius: '6px', width:'121px', height:'40px'}}>
                        <Box color="#FFFFFF" fontSize={14} fontWeight={600} lineHeight="16.8px">Try It For Free!</Box>
                    </Button>
                    <Box onClick={login} component={Button} sx={{ borderRadius: '6px', width:'101px', height:'36px'}} display="flex" justifyContent="center" alignItems="center" gap="8px">
                        <Box color={open ? '#003F2E':"#FFFFFF"} fontSize={14} fontWeight={600} lineHeight="16.8px">Sign in</Box>
                        <ArrowRightIcon fill={open ? '#003F2E':"#FFFFFF"}/>
                    </Box>
                </Box>
            </Box>
            <ToolCategories divID={divID} navFeature={navFeature} open={open} setOpen={setOpen} redirectHandler={redirectHandler} handleClickContactUs={handleClickContactUs}/>
        </Box>
    )
}